// material-ui
import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';

// project imports
import { DRAWER_WIDTH } from 'config';

const paper = (theme) => ({
  backgroundColor: theme.vars.palette.background.paper,
  backgroundImage: 'none',
  borderRight: `1px solid ${theme.vars.palette.divider}`,
  boxShadow: 'none',
  overflowX: 'hidden',
  overflowY: 'hidden', // SimpleBar draws the (thin) scrollbar – no second browser scrollbar
  '& .simplebar-scrollbar::before': { backgroundColor: 'rgba(16,24,40,0.22) !important', borderRadius: '4px !important', width: '4px !important' },
  '& .simplebar-track.simplebar-vertical': { width: '6px !important', background: 'transparent !important' }
});

const openedMixin = (theme) => ({
  width: DRAWER_WIDTH,
  transition: theme.transitions.create('width', { easing: theme.transitions.easing.sharp, duration: theme.transitions.duration.enteringScreen }),
  ...paper(theme)
});

const closedMixin = (theme) => ({
  width: theme.spacing(8),
  transition: theme.transitions.create('width', { easing: theme.transitions.easing.sharp, duration: theme.transitions.duration.leavingScreen }),
  ...paper(theme)
});

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  variants: [
    {
      props: ({ open }) => open,
      style: { ...openedMixin(theme), '& .MuiDrawer-paper': openedMixin(theme) }
    },
    {
      props: ({ open }) => !open,
      style: { ...closedMixin(theme), '& .MuiDrawer-paper': closedMixin(theme) }
    }
  ]
}));

export default MiniDrawerStyled;
